import {CustomerContactPerson} from './CustomerContactPerson';
import {CustomerAddress} from './CustomerAddress';
import {ProductType} from './ProductType';
import {ProductContent} from './ProductContent';
import {BaseObject} from './BaseObject';

export class ProductCategory extends BaseObject {
    id: number;
    name = '';
    order = 0;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/ProductCategory.ts